import React from 'react'

const UpgradeAccount = () => {
    return (
        <div>
            <h1>Upgrade Account</h1>
        </div>
    )
}

export default UpgradeAccount
